import * as React from 'react';
import { ThemeContext } from 'styled-components';

import { normalizeColor } from '../../Utils/Styles/normalizeColor';

import { Slider, SliderUnitLabels } from './SliderInputStyles';

interface ISliderInputProps {
  unitPrepend?: string;
  unitAppend?: boolean;
}

const SliderInput = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement> & ISliderInputProps>((props, ref) => {
  const { min, max, value: initVal = 0, disabled, unitPrepend, unitAppend, onChange, role, ...rest } = props;

  const { themeTwo } = React.useContext(ThemeContext);

  const [val, setVal] = React.useState(initVal);

  React.useEffect(() => setVal(initVal), [initVal]);

  const handleValChange: React.ChangeEventHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    const value = e.target.value;
    setVal(value);
    if (onChange) { onChange(e); }
  };

  // manages slider track background color to fill in progress
  // done here inline because calculating based on props in SC causes rapid class recreation/re-rendering and bogs heavily
  const progressColor =
    normalizeColor(themeTwo, themeTwo.form.slider && themeTwo.form.slider.track.color.progress[disabled ? 'disabled' : 'default']);

  const trackColor =
    normalizeColor(themeTwo, themeTwo.form.slider && themeTwo.form.slider.track.color.base[disabled ? 'disabled' : 'default']);

  const totalDistance = (max as number) - (min as number);
  const progress = (val as number) - (min as number);
  const ratio = `${(progress / totalDistance) * 100}%`;
  const linearGradient = `linear-gradient(to right, ${progressColor} ${ratio}, ${trackColor} 0)`;

  return (
    <>
      <Slider
        {...rest}
        ref={ref}
        role={role || 'slider'}
        type='range'
        min={min}
        max={max}
        value={val}
        aria-valuemin={min as number}
        aria-valuemax={max as number}
        aria-valuenow={val as number || min as number}
        disabled={disabled}
        onChange={handleValChange}
        style={{
          background: linearGradient
        }}
      />
      <SliderUnitLabels disabled={disabled} width='100%' justifyContent='space-between' >
        <div>{unitPrepend}{min && min.toLocaleString()}{unitAppend}</div>
        <div>{unitPrepend}{max && max.toLocaleString()}{unitAppend}</div>
      </SliderUnitLabels>
    </>
  );
});
export default SliderInput;
